<template>
    <div class="pdf-main">
        <div class="pdf-viewer-container">
            <div class="pdf-toolbar">
            <div class="close" @click="close">
                <van-icon name="arrow-left" />
            </div>
            <button @click="zoomIn">{{$t('text.zoom_in')}}</button>
            <button @click="zoomOut">{{$t('text.zoom_out')}}</button>
            <span>{{$t('text.zoom')}}: {{ (scale * 100).toFixed(0) }}%</span>
            </div>
            
            <div class="pdf-pages-container" ref="pdfContainer">
            <div v-for="page in numPages" :key="page" class="pdf-page-wrapper">
                <pdf
                :src="pdfSrc"
                :page="page"
                :style="{ transform: `scale(${scale})`, transformOrigin: 'top left' }"
                @link-clicked="handleLinkClick"
                ></pdf>
            </div>
            </div>
        </div>

    </div>
</template>

<script>

import pdf from 'vue-pdf'

export default {
  components: { pdf },
  data() {
    return {
      numPages: 0, // 总页数
      scale: 1.0,  // 缩放比例
      loadingTask: null
    }
  },
  props: {
    pdfSrc: String
  },
  mounted(){
    this.loadPDF(this.pdfSrc)
  },
  methods: {
    close(){
        this.$emit('close')
    },
    async loadPDF(url) {
      try {
        // 创建PDF加载任务
        this.loadingTask = pdf.createLoadingTask(url)
        
        // 设置PDF源
        this.pdfSrc = this.loadingTask
        
        // 获取总页数
        const pdfDocument = await this.loadingTask.promise
        this.numPages = pdfDocument.numPages
        
        // 错误处理
        this.loadingTask.onError = (err) => {
          console.error('PDF加载错误:', err)
        }
      } catch (err) {
        console.error('PDF初始化错误:', err)
      }
    },
    
    zoomIn() {
      this.scale = Math.min(this.scale + 0.1, 2.0) // 最大放大到200%
    },
    
    zoomOut() {
      this.scale = Math.max(this.scale - 0.1, 0.5) // 最小缩小到50%
    },
    
    handleLinkClick(page) {
      // 点击PDF内部链接时的处理
      const container = this.$refs.pdfContainer
      const pageElement = container.querySelector(`.pdf-page-wrapper:nth-child(${page})`)
      if (pageElement) {
        pageElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-main {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: black;
    z-index: 99;
    // color: white;
    // .back{
    //     width: 10%;
    //     height: 10%;
    //     position: absolute;
    //     left: 6%;
    //     top: 2%;
    //     z-index: 1;
    //     i{
    //         font-size: 20px;
    //     }
    // }
    .pdf-viewer-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .pdf-toolbar {
        padding: 10px;
        background: #f0f0f0;
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .pdf-pages-container {
        flex: 1;
        overflow-y: auto;
        padding: 20px;
        background: #e0e0e0;
        display: flex;
        flex-direction: column;
        &::-webkit-scrollbar {
            display: none;
        }
    }

    .pdf-page-wrapper {
        margin-bottom: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        background: white;
        display: inline-block; /* 使缩放后的PDF保持正确布局 */
    }

    /* 调整PDF页面间的间距 */
    .pdf-page-wrapper:not(:last-child) {
        margin-bottom: 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/base/pdf.vue